import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../const/Messages";
import * as HuaweiMmeDefaultParametersService from "../../../../../../service/HuaweiMmeDefaultParametersService";
import Loading from "../../../../../Common/Loading/Loading";

const initialValues = {
  id: "",
  ignoredCasesLog: false,
  ignoredCasesIr21: false,
  smAllowed: "",
  maximumBearerNumber: "",
  smsAllowed: "",
  connectplmnOnlyCheckWithIR21: false,
  hssRealmName: "",
  imsihssOnlyCheckWithIR21: false,
  imsigtOnlyCheckWithIR21: false,
  voicedeployOnlyCheckWithIR21: false,
};

/**
  @author Guilherme Almeida
  @date 12/05/2021
 */
export default function HuaweiMMEDefaultParameters() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    HuaweiMmeDefaultParametersService.getHuaweiMmeDefaultParameters()
      .then((defaultParameters) => {
        setValues(defaultParameters);
        setLoading(false);
      })
      .catch(() => {
        history.push("/", { message: ErrorUnexpected, messageType: "error" });
      });
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({
    smAllowed: Yup.string().required(
      "Sm Allowed Of Address is a required field"
    ),
    maximumBearerNumber: Yup.string().required(
      "Maximum Bearer Number is a required field"
    ),
    smsAllowed: Yup.string().required("Sms Allowed is a required field"),
    hssRealmName: Yup.string().required("Hss Realm Name is a required field"),
  });

  function handleSave(values, actions) {
    HuaweiMmeDefaultParametersService.update(values)
      .then(() => {
        history.push("/settings/report/template/sgsn-mme/huawei/default", {
          message: OperationSuccessfully,
          messageType: "success",
        });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          actions.setFieldError("smAllowed", ErrorUnexpected);
        } else if (error.response.data.title) {
          actions.setFieldError("smAllowed", error.response.data.title);
        }
        actions.setSubmitting(false);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>Huawei MME Default Parameters</h5>
          </div>
          <div className="ibox-content">
            <Formik
              initialValues={values}
              validationSchema={schema}
              onSubmit={handleSave}
            >
              {() => (
                <Form>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>GENERAL</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="ignoredCases"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesLog" />
                        <label className="form-check-label pl-2">
                          Ignore value from LOG.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesLog" />
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesIr21" />
                        <label className="form-check-label pl-2">
                          Ignore value from IR21.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesIr21" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>CONNECT PLMN</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="smAllowed"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Sm Allowed:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        className="form-control"
                        name="smAllowed"
                        placeholder="Sm Allowed"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="smAllowed" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="maximumBearerNumber"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Maximum Bearer Number:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        className="form-control"
                        name="maximumBearerNumber"
                        placeholder="Maximum Bearer Number"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="smAllowed" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="smsAllowed"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Sms Allowed:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        className="form-control"
                        name="smsAllowed"
                        placeholder="Sms Allowed"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="smAllowed" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="connectplmnOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        type="checkbox"
                        name="connectplmnOnlyCheckWithIR21"
                      />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="connectplmnOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>IMSI GT</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="imsigtOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="imsigtOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="imsigtOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="pt-2 pb-2 ">
                    <label className="font-weight-bold">IMSI HSS</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="hssRealmName"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Hss Realm Name:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        className="form-control"
                        name="hssRealmName"
                        placeholder="Hss Realm Name"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="smAllowed" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="imsihssOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="imsihssOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="imsihssOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>VOICE DEPLOY</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="voicedeployOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        type="checkbox"
                        name="voicedeployOnlyCheckWithIR21"
                      />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="voicedeployOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings">
                      Cancel
                    </Link>
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
